import { Button, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { CarrierVisitDirection } from '@planning/app/api'
import TruckIlustration from '@planning/components/icon/ilustration/TruckIlustration'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { FC } from 'react'

interface Props {
  direction: CarrierVisitDirection
  onClick: () => void
  disabled?: boolean
}

export const TruckDirection: FC<Props> = ({ direction, onClick, disabled }) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const directionLabel =
    direction === CarrierVisitDirection.Inbound ? t('gateIn', 'Gate in') : t('gateOut', 'Gate out')

  return (
    <Box
      sx={{
        maxWidth: '420px',
        width: '100%',
        padding: '1rem',
        borderRadius: theme.customRadius.medium,
        margin: '0 auto 1rem auto!important',
        textAlign: 'center',
        bgcolor: theme.palette.common.white,
        boxShadow: '0px 8px 16px 0px rgba(145, 158, 171, 0.16)',
      }}
    >
      <Box sx={{ opacity: disabled ? 0.5 : 1 }}>
        <TruckIlustration
          horizontalFlip={direction === CarrierVisitDirection.Outbound ? true : false}
        ></TruckIlustration>
      </Box>
      <Button
        variant='contained'
        size='large'
        sx={{ width: '100%', mt: '1rem' }}
        data-cy={`gate-passage-truck-button-${direction.toLocaleLowerCase()}`}
        onClick={onClick}
        disabled={disabled}
      >
        {directionLabel}
      </Button>
      {disabled && (
        <Typography
          variant='caption'
          color='text.disabled'
          sx={{ display: 'block', mt: theme.customSpacing.xs }}
        >
          {t('notAvailableAtThisGate', 'Not available at this gate')}
        </Typography>
      )}
    </Box>
  )
}
